module.exports = "<router-outlet>\n  <app-spinner><app-title></app-title></app-spinner>\n</router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/auth/auth.component.html
// module id = ./src/app/layout/auth/auth.component.html
// module chunks = main